<template>
    <a-card size="small" title="中间件管理">
        <div slot="extra" style="width:200px;float:right;">
            <v-gobackbutton>返回</v-gobackbutton>
            <a-button type="primary" class="fr mr20" slot="extra" @click="handleNew">新建</a-button>

        </div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="getAppSumData">
            <a-form-item label="选择环境">
                    <a-icon type="menu-unfold-outlined" style="color: #0070cc" />

                <a-button type="normal" @click="handleEnvClick">
                    {{kadesc}}
                    <a-icon type="down" style="color: #0070cc" />
                </a-button>

                <kaenvselecter ref="envSelecter" @onModalHide="handleEnvSelect"></kaenvselecter>
            </a-form-item>
            <a-form-item label="中间件类型">
                <a-select v-model="middlewaretype" style="width:150px;">
                    <a-select-option v-for="(value,name) in typeNames" :key="name" :value="value">
                        {{name}}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getAppSumData">查询</a-button>
            </a-form-item>

             <a-form-item>
                <a-button type="default" htmlType="submit" :key="this.loading.key" @click="handleSearchReset">重置
                </a-button>
            </a-form-item>
        </a-form>
        <!-- 系统列表 -->
        <a-table :columns="columns" :data-source="tableData" class="mt20" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">

            <template slot="middlewaretype" slot-scope="text">
                <span>{{typeNames[text]}}</span>
            </template>
            <template slot="configtype" slot-scope="text,record">
                <span>{{configtypeNames[record.middlewaretype][text]}}</span>
            </template>
            <template slot="operation" slot-scope="text, record">
                <div class="editable-row-operations">
                    <a-button type="link" @click="handleView(record)">详情</a-button> 
                    <a-button type="link" @click="handleEdit(record)">编辑</a-button> 
                    <a-popconfirm  title="确认删除?" @confirm="() => onDelete(record)">
                        <a  href="javascript:;" style="margin-right:10px;">删除</a>
                    </a-popconfirm>
                </div>
            </template>
            
        </a-table>

    </a-card>
</template>
<script>
import kaenvselecter from '../com/kaenvselecter.vue'

let typeNames = {
    'rocketmq':'rocketmq',
    'zookeeper':'zookeeper',
    'redis':'redis',
}

let configtypeNames = {
    'zookeeper':{
        'dubbo.zookeeper.address.qt':'dubbo前台注册中心v5',
        'dubbo.zookeeper.address.zt':'dubbo中台注册中心v5',
        'dubbo.zookeeper.address.jt':'dubbo基础注册中心v5',
        'dubbo.zookeeper.address.v3':'dubbo注册中心v3',
        'dubbo.metadata.center':'dubbo元数据中心',
        'dubbo.config.center':'dubbo配置中心',
        'scm.address':'应用动态配置中心',
    },
    'rocketmq':{
        'rocketmq.address.qt': '前台mq',
        'rocketmq.address.zt': '中台mq',
        'rocketmq.address.jt':  '基础mq',
        'rocketmq.addres.v3': 'v3mq',
    },
    'redis':{
        'redis.address.qt':'前台缓存',
        'redis.address.zt':'中台缓存',
        'redis.address.jt':'基础缓存',
        'redis.address.v3':'v3缓存'
    }
}

const columns = [
    {
        title: "序号",
        width: 80,
        align: "center",
        customRender: (text, record, index) => {
            return  index + 1;
        }
    },
    { 
        title: '中间件类型', 
        dataIndex: 'middlewaretype',
        align:'center',
        scopedSlots:{ customRender:'middlewaretype' },
        width:100, 
    },
    { 
        title: '配置类型', 
        dataIndex: 'configtype',
        scopedSlots:{ customRender:'configtype' },
        align:'center',
        width:200, 
    },
    // { 
    //     title: '配置值', 
    //     dataIndex: 'configval',
    //     align:'center',
    //     ellipsis:true,
    //     width:200, 
    // },

    { 
        title: '描述', 
        dataIndex: 'desc',
        ellipsis:true,
        align:'center',
        width:200, 
    },
    { 
        title: '更新时间', 
        dataIndex: 'updatetime',
        align:'center',
        ellipsis:true,
        width:200, 
    },
    { 
        title: '创建时间', 
        dataIndex: 'createtime',
        align:'center',
        width:200, 
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        // fixed:'right',
        scopedSlots: { customRender: 'operation' },
    }

];
export default {
    components:{
        kaenvselecter
    },
    data() {
        return {
            form: this.$form.createForm(this),
            columns,
            tableData:[],
            typeNames,
            configtypeNames,
            tloading:false,
            clientWidth:800,
            kaenv:'',
            kadesc:'',
            middlewaretype:''

        };
    },
    methods: {
        //解除关联
        onDelete(record) {
            this.$store.dispatch({
                type: "kamanager/delMiddleware",
                params: {
                    id:record.id,
                }
            }).then(() => {
                this.getAppSumData();
            });
        },

        handleEnvClick(){
            this.$refs.envSelecter.modalState.isShow = true;
        },
        handleEnvSelect(envList){
            if(envList){
                let env =  envList[0];
                this.kaenv = env.kaenv;
                this.kadesc = env.kadesc;
            }
            this.$refs.envSelecter.modalState.isShow = false;
            this.getAppSumData();

        },
        handleView(record){
            this.$router.push({
                path:'detailMiddleware',
                query:{
                    kaenv:this.kaenv,
                    id:record.id,
                    kadesc:this.kadesc,
                }
            })
        },
        handleNew(){
            this.$router.push({
                path:'addMiddleware',
                query:{
                    kaenv:this.kaenv,
                    kadesc:this.kadesc,
                    id:''
                }
            })
        },
        handleEdit(record){
            this.$router.push({
                path:'editMiddleware',
                query:{
                    kaenv:this.kaenv,
                    id:record.id,
                    kadesc:this.kadesc,
                }
            })
        },
        handleSearchReset(){
            this.keyword = ''
            this.getAppSumData()
        },
        getAppSumData(){
            let that = this
            that.tloading = true
            let params = {
                middlewaretype:that.middlewaretype,
                kaenv:that.kaenv,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'kamanager/listMiddleware',
                params:params
            }).then((res)=>{
                that.tloading = false;
                let result = res.data.data;
                that.tableData = result;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(){
            this.getAppSumData();
        },
    },
    mounted(){
    }
};
</script>

<style scoped>
.my-input{
        padding: 4px 20px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 1.5;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    cursor: pointer;
}
</style>
